const axios = window.axios;
import { usermavenClient } from '@usermaven/sdk-js'

export default {
    install: (app, options) => {
        const isEnabled = import.meta.env.VITE_USERMAVEN_ENABLED == 'true' ? true : false
        const EVENT_TYPES = {
            SIGNED_UP: 'signed_up',
            LOGGED_IN: 'logged_in',
            LOGGED_OUT: 'logged_out',
            TRIAL_STARTED: 'trial_started',
            TRIAL_ENDED: 'trial_ended',
            PLAN_UPGRADED: 'plan_upgraded',
            PLAN_DOWNGRADE: 'plan_downgraded',
        }
        if (isEnabled) {
            try {
                window.usermaven = usermavenClient({
                    // Required Configuration
                    key: import.meta.env.VITE_USERMAVEN_API_KEY,           // Your Usermaven API key
                    trackingHost: 'https://' + import.meta.env.VITE_USERMAVEN_TRACKING_HOST,  // Your tracking server URL
                    
                    // Optional Configuration
                    autocapture: true,             // Enable automatic event capturing
                    autoPageview: true,            // Automatically track page views
                    randomizeUrl: false,           // Randomize URLs to avoid PII collection
                    
                    // Cross-domain Tracking ( Optional )
                    crossDomainLinking: true,     // Enable cross-domain tracking
                    domains: 'instawp.com,instawp.io,app.instawp.io,central.app.io',       // Specify allowed domains
                })
            } catch (error) {
                console.log(error);
            }
        }
        const setUpUserMaven = (user) => {
            if (isEnabled && window.usermaven) {
                // 
                if (!user || !user.masked_email) {
                    return
                }
                const names = user.name ? user.name.split(" ") : ['', '']
                const payload = {
                    id: user.id,
                    email: user.masked_email,
                    created_at: user.sign_up_date,
                    first_name: names[0],
                    last_name: names[1] ?? null,
                    custom: {
                        plan_name: user.base_plan_name,
                        last_login_date: user.logged_in_at,
                        is_verified: user.is_verified,
                        is_paid: user.is_paid,
                        team_plan: user.team_base_plan_name,
                        on_trial: user.onTrial
                    },
                }
                payload.id = payload?.id?.toString()
                window.usermaven.id(payload)
                if (!user.is_usermaven_identified) {
                    console.log('usermaven identified', user.masked_email);
                    axios.post("/api/v2/user-maven-identified")
                }
            }
        }
        const trackEvent = (event, payload) => {
            if (isEnabled && window.usermaven) {
                window.usermaven.track(event, payload)
            }
        }
        const reset = () => {
            if (isEnabled && window.usermaven) {
                console.log(window.usermaven);
                window.usermaven.reset(true)
            }
        }
        if (options.user) {
            setUpUserMaven(options.user)
        }
        app.config.globalProperties.$usermaven = {
            eventTypes: EVENT_TYPES,
            setUpUserMaven: setUpUserMaven,
            trackEvent: trackEvent,
            reset: reset
        }
    }
}
